import React from 'react'
import styles from "./description.module.css";
const Description = ({des='text', padding='15px'}) => {

  return (
    <div className={styles.des} style={{paddingTop:padding}}>{des}</div>
  )
}

export default Description